import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import * as z from "zod";
import { canResetReturn } from "../../returns/return-action-eligibility";
import { defineReturnAction } from "../types";

/** No step or flow: bulk resets to the flow's default reset step, else the flow start. */
const BulkResetPayloadSchema_ = z.object({ resetReason: z.string() });
export interface ResetPayload extends z.infer<typeof BulkResetPayloadSchema_> {}

export const resetReturnAction = defineReturnAction<ResetPayload>({
  label: "Reset",
  mutation: "resetReturns",
  permissions: [ReturnsAndClaimsPermissions.RESET_RETURN],
  irreversible: true,
  isEligible: ({ return_ }) => canResetReturn({ return_ }),
  payloadSchema: BulkResetPayloadSchema_,
  examplePayload: { resetReason: "Customer picked the wrong items" },
});
